import { Product } from '../store/order/Order';

export default (a: Product, b: Product) => {
  if (a.factor < b.factor) return +1;
  if (a.factor > b.factor) return -1;
  return 0;
};
